import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DashboardService } from '../Dashboad.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Carousel } from 'primeng/carousel';

@Component({
  selector: 'app-learnings',
  templateUrl: './learnings.component.html',
  styleUrls: ['./learnings.component.css']
})
export class LearningsComponent implements OnInit, OnChanges, OnDestroy {
  userId: any;
  data: any;
  employeeId: number;
  length: number;

  private isDestroyed = false;
  currentCarouselItem: number = 3;

  @Input() totalCoursesOfEmp: Number;
  @Input() learnings: any[];
  @Input() programProgress = {};
  @ViewChild('carousel') carousel: Carousel;

  constructor(private service: DashboardService, private router: Router) { }

  ngOnInit() {
    
    //this.learnings = this.learnings ?? [];
    //this.userId = localStorage.getItem('userId');
    //this.employeeId = parseInt(localStorage.getItem('Id'))
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
  }
  // getMyLearningsOfEmployee(userId: number,employeeId:number){
  //   this.service.getMyLearningsOfEmployee(userId,employeeId).subscribe(x => {
  //     this.data = x;
  //   })

  // }
  // navigatetoESD(){

  //   window.open(environment.esdMyLearningUrl+'/programs')

  // }
  // navigatetoESDId(num : number){
  //   const url = environment.esdMyLearningUrl +'/programs/'+num;
  //   window.open(url)
  // }


  async getImage(fileId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.service.getFileDownloadLink(fileId).subscribe(
        res => {
          if (res) {
            resolve(res.url);
          } else {
            reject('URL not found in response');
          }
        },
        err => reject(err)
      );
    });
  }



  goToAllLearnings() {
    
    this.router.navigateByUrl('Home/employee-career/employee-Career-program');
  }

  goToPrograms(program) {
    this.router.navigateByUrl('Home/Dashboard/Program Description/' + program.programID, { state: { prevUrl: 'Home/Dashboard' } });
  }

  navigateForward(event: any) {
    this.currentCarouselItem += 1;
    this.carousel.navForward(event);
  }

  navigateBackward(event: any) {
    this.currentCarouselItem -= 1;
    this.carousel.navBackward(event);
  }
  async fetchImageUrl(learning: any) {
    const Url = await this.getImage(learning.programImage);
    learning.url = Url;
  }
  async ngOnChanges(changes: SimpleChanges) {
    if (changes['learnings'] && this.learnings) {
      for (const course of this.learnings) {
        // If the component is destroyed, stop fetching more images.
        if (this.isDestroyed) {
          break;
        }
        if (course.programImage) {
          try {
            await this.fetchImageUrl(course);
          } catch (error) {
            if (this.isDestroyed) break;
            console.error(`Failed to fetch image for course:`, course, error);
          }
        }
      }
    }
    if (changes['programProgress']) {
    }
  }
}
